import React from 'react';
import { Link } from 'react-router-dom';
import { Fish } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#D4AF37]/20 bg-[#0a0a0a] pt-16 pb-8 mt-24">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Fish size={22} className="text-[#D4AF37]" />
            <span className="font-serif-display text-xl text-gold-gradient font-black">Golden Fish</span>
          </div>
          <p className="text-sm text-[#C0C0C0]/80 leading-relaxed">
            South Africa's weekly R10,000 Golden Catch draw. Fair, transparent, and licensed.
          </p>
        </div>
        <div>
          <h4 className="font-serif-display text-sm uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Play</h4>
          <ul className="space-y-2 text-sm text-[#C0C0C0]/80">
            <li><Link to="/buy-ticket" className="hover:text-[#D4AF37]">Buy a Ticket</Link></li>
            <li><Link to="/winners" className="hover:text-[#D4AF37]">Previous Winners</Link></li>
            <li><Link to="/faq" className="hover:text-[#D4AF37]">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif-display text-sm uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Account</h4>
          <ul className="space-y-2 text-sm text-[#C0C0C0]/80">
            <li><Link to="/login" className="hover:text-[#D4AF37]">Login</Link></li>
            <li><Link to="/signup" className="hover:text-[#D4AF37]">Sign up</Link></li>
            <li><Link to="/dashboard" className="hover:text-[#D4AF37]">Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif-display text-sm uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-[#C0C0C0]/80">
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-[#D4AF37]">Terms &amp; Conditions</Link></li>
            <li className="text-[#808080]">Licensed under [License #: Pending]</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-[#D4AF37]/10 text-center">
        <p className="text-xs text-[#808080] mb-1">
          18+ only. Gamble responsibly. Problem Gambling Helpline: <span className="text-[#C0C0C0]">0800 006 008</span>
        </p>
        <p className="text-xs text-[#808080]">© {new Date().getFullYear()} Golden Fish Lottery. All rights reserved.</p>
      </div>
    </footer>
  );
}
